import React from "react";
import { nl2br } from "@/src/services/formServiceFunctions";
import RecommendationBox from "@/src/components/Form/RecommendationBox";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type RecommendationProps = {
  product: AbstractCase;
};

const Recommendation = ({ product }: RecommendationProps) => {
  if (product.administrativeDecisionRecommendation === "individualText") {
    return (
      <RecommendationBox>
        {product.administrativeDecisionRecommendationText && (
          <p dangerouslySetInnerHTML={{ __html: nl2br(product.administrativeDecisionRecommendationText) }} />
        )}
      </RecommendationBox>
    );
  }

  let recommendationText;
  switch (product.administrativeDecisionRecommendation) {
    case "objection":
      recommendationText = (
        <p>
          In Ihrem Fall haben wir den vorliegenden Bescheid rechtlich geprüft und sehen gute Argumente, die gegen die Entscheidung der Behörde sprechen. Aus
          unserer Sicht hat der Dienstherr den Sachverhalt nicht vollständig gewürdigt oder rechtliche Vorgaben fehlerhaft angewendet. Um Ihre Rechte zu wahren,
          ist es nun zwingend erforderlich, das sogenannte Vorverfahren einzuleiten. Ohne einen fristgerechten Widerspruch wird der Bescheid bestandskräftig und
          kann später nicht mehr angegriffen werden.{" "}
          <strong>Wir empfehlen Ihnen daher, Widerspruch gegen den Bescheid einzulegen, um eine Korrektur der Entscheidung zu erwirken.</strong>
        </p>
      );
      break;
    case "accept":
      recommendationText = (
        <p>
          In Ihrem Fall haben wir den vorliegenden Bescheid eingehend rechtlich geprüft. Leider müssen wir Ihnen mitteilen, dass die Erfolgsaussichten für ein
          Vorgehen gegen diesen Bescheid gering sind. Nach unserer Einschätzung hat die Behörde die gesetzlichen Vorgaben eingehalten und ihren
          Ermessensspielraum voraussichtlich korrekt ausgeübt. Ein Widerspruch würde unserer Auffassung nach wahrscheinlich von der Behörde als unbegründet
          zurückgewiesen werden.{" "}
          <strong>
            Wir empfehlen Ihnen daher, um unnötige Kosten und Aufwand zu vermeiden, den Bescheid zu akzeptieren und den Fall an dieser Stelle abzuschließen.
          </strong>
        </p>
      );
      break;
    default:
      return null;
  }

  return (
    <RecommendationBox>
      {recommendationText}
      {product.administrativeDecisionRecommendation !== "objection" && (
        <p>
          Wir empfehlen Ihnen daher, <strong>keinen Widerspruch einzulegen und den Fall an dieser Stelle abzuschließen.</strong>
        </p>
      )}
      {product.extrajudicialRecommendation === "objection" && <p>Um Ihre Forderungen durchzusetzen, empfehlen wir Ihnen, Widersprich einzulegen.</p>}
      {product.administrativeDecisionRecommendationText && <p dangerouslySetInnerHTML={{ __html: nl2br(product.administrativeDecisionRecommendationText) }} />}
    </RecommendationBox>
  );
};

export default Recommendation;
